export const phonenumber = new RegExp(
  /(?:^((?!00|[+])|(?:(?:00|[+])47))(\d{8})$)|(?:^(?:00|[+])(?!47)(\d{7,15})$)/
)

export const mobilenumber = new RegExp(
  /(?:^((?!00|[+])|(?:(?:00|[+])47))([49]\d{7})$)|(?:^(?:00|[+])(?!47)([49]\d{7,15})$)/
)

export const exclusiveNumbers = new RegExp(/^\d+$/)

export const email = new RegExp(
  /(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*@(?:[a-zA-ZæÆøØåÅ0-9-]+\.)+[a-zA-Z]{2,}(?:\s?[;,:\s]\s?)?)+/
)

export const url = new RegExp(
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{2,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/
)

export const emoji = new RegExp(
  /(?![©®](?!\uFE0F))(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
)
